import React from "react";
import Select from "react-select";
import './index.css'

const DropDown = (props) => {
    const {children, uniqueKeys, getDropdownFields, selectOnChange, selected, positionCodeIndex, data, isEditable } = props;
    const getSelectedValue = (ref) => {
      const refValueObj = data?.positionCodeAdditionalDetails?.find(ele =>  ele?.refType === ref)
      return {
        value: refValueObj,
        label: refValueObj?.refValue,
      }
    }
  return (
    <div className="dropdown-parent-container">
    {selected &&
      uniqueKeys?.length > 0 &&
      uniqueKeys?.map((ele, refIndex) => (
        <div key={refIndex} className="dropdown-select">
          <label className="dropdown-label">
            {ele}
          </label>
          <Select
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                minWidth: 200,
                maxWidth: 400,
              }),
            }}
            defaultValue={getSelectedValue(ele)}
            options={getDropdownFields(ele)}
            onChange={(action) => selectOnChange(action, positionCodeIndex, refIndex)}
            isDisabled = {data?.isExistingUser || isEditable }
          />
        </div>
      ))}
      {children && <div className="dropdown-select">
        {children}
      </div>}
  </div>
  );
};

export default DropDown;
